module.exports = __webpack_public_path__ + "img/mitid.40c54d73.png";